import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const vouchersRoutesDictionary = moduleRouteDictionaryFactory(
  'vouchers',
  'vouchers',
  {
    list: 'list',
    detail: 'detail/:id',
  },
);
